import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import ConfirmDelete from '../../../../components/ConfirmDelete'
import ButtonsGrid from '../../../../components/ButtonsGrid'
import Table from '../../../../components/Table'
import auth from '../../../../utils/auth'
import cfg from '../../../../utils/config'
import axios from 'axios'

class GridMulticastGroups extends Component {
    applicationId = this.props.applicationId

    state = {
        data: [],
        loading: true,
        redirectToEdit: false,
        table: null
    }

    getData = (state) => {
        this.setState({ loading: true })
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/lns/application/${this.applicationId}/multicast/group/?limit=` + state?.lineCount + state.filter

        if (state.url) {
            url = state.url
        }

        axios.get(url, config_me).then((res) => {
            this.setState({
                loading: false,
                data: res.data.results,
                count: res.data.count,
                next: res.data.next,
                previous: res.data.previous
            })
        })
    }

    deletar = () => {
        let requestArray = []
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        this.setState({ loading: true, enableDeletar: false, enableEditar: false })

        this.state?.table?.state.selected.map((value, index) =>
            requestArray.push(axios.delete(cfg.base_api_url + cfg.api_v2 + `/${userInfo.empresa}/lns/application/${this.applicationId}/multicast/group/${value}/`, config_me))
        )

        axios.all(requestArray).then(axios.spread((acct, perms) => {
            this.state?.table?.fetch()
            this.state?.table?.unselect()
        }))
    }

    editar = () => {
        let toGo = `/lns/application/${this.applicationId}/multicast-group/` + this.state?.table?.state.selected?.[0] + "/editar"
        let from = { pathname: toGo }
        this.setState({ redirectToEdit: from })
    }

    convertDate = (date) => new Date(Date.parse(date)).toLocaleDateString('pt-BR',
        { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
    )

    render() {
        const { redirectToEdit, table } = this.state
        if (redirectToEdit) {
            return <Redirect to={redirectToEdit} />
        }

        const columns = [
            {
                Header: 'Nome',
                Accessor: 'name',
                Cell: (original) => {
                    return <Link to={`/lns/application/${this.applicationId}/multicast-group/${original.id}/editar`}>{original.name}</Link>
                }
            }, 
            {
                Header: 'Região',
                Accessor: 'region'
            }, 
            {
                Header: 'Criado em',
                Accessor: 'created_at',
                Cell: (original) => {
                    return <span>{this.convertDate(original.created_at)}</span>
                }
            }, 
            {
                Header: 'Atualizado em',
                Accessor: 'updated_at',
                Cell: (original) => {
                    return <span>{this.convertDate(original.updated_at)}</span>
                }
            }
        ]

        return (
            <>
                <div>
                    <div className="hdv-btn-group">
                        <ButtonsGrid
                            route="/multicast/group"
                            buttons={[
                                {
                                    method: "post",
                                    button: <Link to={`/lns/application/${this.applicationId}/multicast-group/novo`}><button className="hdv-btn-forms hdv-btn-green ">Novo</button></Link>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={table?.state.enableEditar ? this.editar : null} className={"hdv-btn-forms hdv-btn-yellow " + (table?.state.enableEditar ? "" : "hdv-btn-disable")}>Editar</button>
                                },

                                {
                                    method: "delete",
                                    button: <ConfirmDelete enabled={table?.state.enableDeletar} action={this.deletar} />
                                }
                            ]}
                        />
                    </div>

                    <Table
                        checkbox
                        notEditFirstColum={true}
                        data={this.state.data}
                        loading={this.state.loading}
                        count={this.state.count}
                        next={this.state.next}
                        previous={this.state.previous}
                        columns={columns}
                        onFetchData={this.getData}
                        onUpdate={(table) => this.setState({ table })}
                    />
                </div>
            </>
        )
    }

}

export default GridMulticastGroups